// ── IMAGE SLOTS (School Show Ready) ────────────────────────────
// Hosted in the Impultienda store resources (Recursos).
const STORE = '7e6b6170-c536-41a3-99ad-9957b3b863f1';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code (no AI text): the Gamma Studio cover plus
 * real pages 4 and 12 on the iMac, and the Impultienda bonus photos with their titles typed in. Pure white background.
 */
const IMAC = RES + '1792672604651_ssr-mockup-imac-d57eea00.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as pageCaptions: p.4, 11, 12, 13, 38, 39 (checked clean in QC) */
export const pageImages: string[] = [
  RES + '1792672629694_ssr-pagina-04-show-year-dc2d55ae.webp',
  RES + '1792672653493_ssr-pagina-11-play02-8b2a20cf.webp',
  RES + '1792672657614_ssr-pagina-12-script1-30eeebfa.webp',
  RES + '1792672662335_ssr-pagina-13-script2-2af6cbc5.webp',
  RES + '1792672666980_ssr-pagina-38-index-0725aaf2.webp',
  RES + '1792672671488_ssr-pagina-39-planner-8f8e3564.webp',
];
export const pageCaptions: string[] = [
  'Your school show year',
  'Play 02 · the play',
  'Play 02 · script part 1',
  'Play 02 · script part 2 & rehearsals',
  'When rehearsals get hard + play index',
  'Show planner + cast list',
];
/** 5 bonus covers (titles typed in code), in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  RES + '1792672609379_ssr-bono-1-ensayo-67ec59b6.webp',
  RES + '1792672612898_ssr-bono-2-poemas-f6416efe.webp',
  RES + '1792672617251_ssr-bono-3-imprimibles-426886f0.webp',
  RES + '1792672621442_ssr-bono-4-backstage-6bcbd769.webp',
  RES + '1792672625373_ssr-bono-5-disfraces-f806ce80.webp',
];
